import angular from 'angular';

import { logger } from '../services/logger';

export default angular.module('est.webpackTemplate', []).config(config);

config.$inject = ['$provide'];

function config($provide: angular.auto.IProvideService) {
  decorateTemplateRequest({ $provide });
}

/**
 * Override default angular template request logic to resolve all templates using webpack
 *
 * Based on: https://stackoverflow.com/questions/40583393/angularjs-templateurl-via-post-method
 */
function decorateTemplateRequest({
  $provide,
}: {
  $provide: angular.auto.IProvideService;
}) {
  $provide.decorator('$templateRequest', [
    '$templateCache',
    '$q',
    '$delegate',
    /**
     * @param {angular.ITemplateCacheService} $templateCache
     * @param {angular.IQService} $q
     * @param {(templateUrl: string) => void} $delegate
     */
    ($templateCache, $q, $delegate) => {
      // Return a function that will be
      // called when a template needs to be fetched
      return (/** @type {string} */ templateUrl) => {
        // Check if the template is already in cache
        let tpl:
          | string
          | [
              statusCode: number,
              html: string,
              headers: { [key: string]: string },
              statusText: string,
            ]
          | undefined = $templateCache.get(templateUrl);

        if (tpl === undefined) {
          if (typeof templateUrl !== 'string' || !templateUrl.startsWith('~')) {
            // If you only sometimes want to use POST and sometimes you want
            // to use GET instead, you can check here if the request should
            // be normal GET request or not. If it should, just use $delegate
            // service and it will call the original fetcher function.

            return $delegate(templateUrl);
          }

          try {
            tpl = require(
              `app/${
                // strip .html or .html?raw
                templateUrl.replace(/\.html.*$/, '').replace('~app/', '')
              }.html`,
            );

            $templateCache.put(templateUrl, tpl);

            return $q.resolve(tpl);
          } catch (error) {
            logger.error(`Error resolving ${templateUrl}`, {
              error,
            });

            throw error;
          }
        }

        return $q.resolve(
          typeof tpl === 'object' && typeof tpl[1] === 'string'
            ? // looks like angular stores template with additional data from http response
              tpl[1]
            : tpl,
        );
      };
    },
  ]);
}
